import { mapProps } from 'recompose';
import { compose, path } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import { Button } from 'js/components/common/Button';
import React, { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { useGetPageRoutingURL } from 'js/hooks/useGetPageRoutingURL';
import { withTranslations } from 'js/components/hocs/withTranslations';

import style from './index.scss';

export const MoreDetails = ({
    label,
    onClick,
    className = '',
    view = 'secondary',
    variant = 'rounded',
    color = 'info',
    size = 'large'
}) => (
    <div className={style.container}>
        <Button
            className={`${style.btn} ${className}`}
            view={view}
            variant={variant}
            color={color}
            size={size}
            onClick={onClick}>
            {label}
        </Button>
    </div>
);

export const useOnClick = (leaderBoardLink) => {
    const navigate = useNavigate();

    return useCallback(() => {
        navigate(leaderBoardLink);
    }, [navigate, leaderBoardLink]);
};

export default compose(
    withTranslations,
    mapProps(
        ({ t, leaderboardId, ...rest }) => {
            const page = useAppSelector(path(['leaderboard', 'page']));
            const leaderBoardLink = useGetPageRoutingURL(`${page}/${leaderboardId}`);
            const onClick = useOnClick(leaderBoardLink);

            return {
                ...rest,
                onClick,
                label: t('playtech.mobile.system.leaderboard.moreDetails')
            };
        }
    )
)(MoreDetails);
